import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './status-indicator.module.css'

// I can't type the "availableStyles" property, because i don't know the type of a whole CSS class.
// Is it "PropTypes.objectOf(PropTypes.objectOf(PropTypes.string))" ?

StatusIndicator.propTypes = {
    activeStyle: PropTypes.string.isRequired,
    availableStyles: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string
}

StatusIndicator.defaultProps = {
    className: ''
}

/**
 * @constructor
 *
 * This <code>StatusIndicator</code> can be used within the {@link StatusIcon} as the child.
 * @see {@link https://tttconfluence.ttg.global:8443/display/TTB/Molecules#Molecules-ViewHeader}
 *
 * @param {Object} availableStyles   - the styles object derived from a CSS file which contains all available
 *                                     CSS classes, which can be set as 'activeStyle'.
 * @param {string} activeStyle       - the name of the active CSS class from the 'availableStyles' which specifies
 *                                     the background color of the status.
 * @param {string} [className='']    - a custom CSS class name for the outer DIV element.
 *
 * @example
 *     import styles from './my-status-colors.module.css'
 *
 *     <StatusIndicator availableStyles={styles} activeStyle='green' />
 */
function StatusIndicator({ activeStyle, availableStyles, className }) {
    return <div className={cx(styles['indicator'], availableStyles[activeStyle], className)} />
}

export default StatusIndicator
